// import Movimentos from './Index.vue'
import Permissions from "../../models/Permissions";

const Movimentos = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/movimentos",
    name: "Movimentos",
    component: Movimentos,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Movimentos",
      icon: "fa fa-usd",
      group: "Controladoria",
      permissions,
    },
  },
];
